// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fullsize[data-v-d5fc04c4]{width:100%;height:100%;min-height:100%;border-radius:inherit}.user[data-v-d5fc04c4]{display:flex;align-items:center}.user__photo[data-v-d5fc04c4]{min-width:44px;max-width:44px;height:44px;position:relative;border-radius:40px;margin-right:12px}.user__photo[data-v-d5fc04c4] .el-skeleton__item{width:100%;height:100%;border-radius:inherit}.user__info[data-v-d5fc04c4]{display:flex;flex-direction:column;width:100%}", ""]);
// Exports
module.exports = exports;
